import React, { Component } from 'react';

import './Pages.scss';
import Body from './Body';
import Header from '../Components/Header';
import Sidemenu from '../Components/SideMenu';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getBotListData, blockUiFun } from '../Redux/Actions/uiActions'
import Relogin from '../Components/Relogin';
import ERROR from './Error';


class Pages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: ''
        }
    }

    componentDidMount() {
        this.props.blockUiFun(true);
        this.props.getBotListData(() => {
            this.setState({ message: '' });
            // this.props.blockUiFun(false);
        }, (e) => {
            setTimeout(() => {
                this.setState({ message: '' + e });
            }, 1000);
            this.props.blockUiFun(false);
        });
    }

    loadComponent = () => {
        return (
            <div>
                <div id='toast-msg'>
                    <div id="toast-error"></div>
                    <div id="toast-success"></div>
                </div>
                <div className='bot-forge-body-wrapper'>
                    <div className='bot-forge-body bot-forge-main-page'>
                        <section>
                            <div className='sidebar-section no-padding'>
                                <Sidemenu
                                    children = {
                                        <div className='header-body-container no-padding'>
                                            <Header key={new Date().getTime()} />
                                            <Body />
                                        </div>
                                    }
                                />
                            </div>
                            {/* <div className='header-body-container no-padding'>
                                <Header key={new Date().getTime()} />
                                <Body />
                            </div> */}
                        </section>
                        <Relogin {...this.props} key={this.props.reloginUser} />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return this.state.message === '' ? this.loadComponent() : <ERROR />;
    }
}

const mapStateToProps = state => {
    return {
        selectedBotID: state.UiReducer && state.UiReducer.selectedBotID ? state.UiReducer.selectedBotID : false,
        reloginUser: state.UiReducer && state.UiReducer.reloginUser ? state.UiReducer.reloginUser : false
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getBotListData,
        blockUiFun
    },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Pages);